"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogManager_1 = require("../../Log/LogManager");
const IChatMessageAttachmentStore_1 = require("../IChatMessageAttachmentStore");
const ChatMessageAttachmentStatus_1 = require("../ChatMessageAttachmentStatus");
class ChatMessageAttachmentIndexedDbStore {
    constructor(db) {
        this._logger = LogManager_1.logManager.GetLogger("ChatMessageAttachmentIndexedDbStore");
        this.db = db;
    }
    async InitAsync() { }
    async ClearAsync() {
        await this.db.chatMessageAttachments.clear();
    }
    async SaveAsync(name, attachmentBytes) {
        if (!name)
            throw new IChatMessageAttachmentStore_1.ChatMessageAttachmentStoreError(`Attachment=${name} should not be empty.`);
        if (attachmentBytes.size === 0)
            throw new IChatMessageAttachmentStore_1.ChatMessageAttachmentStoreError(`Attachment=${name} size should > 0`);
        const cmAttachmentDao = await this.db.chatMessageAttachments.get(name);
        if (!cmAttachmentDao) {
            //Add case
            const cmas = new ChatMessageAttachmentStatus_1.ChatMessageAttachmentStatus({
                Name: name,
                IsInStorage: true,
            });
            await this.db.chatMessageAttachments.add({
                id: name,
                status: this.ToIChatMessageAttachmentStatusIndexedDbDao(cmas),
                attachment: attachmentBytes
            });
        }
        else {
            //Update case
            const newCmas = (this.ToChatMessageAttachmentStatus(cmAttachmentDao.status)).ApplyIsInStorage(true);
            await this.db.chatMessageAttachments.put({
                id: name,
                status: this.ToIChatMessageAttachmentStatusIndexedDbDao(newCmas),
                attachment: attachmentBytes
            });
        }
    }
    async SaveFromStreamAsync(name, attachmentStream, streamLength) {
        throw new Error('Not Implemented');
    }
    async LoadAsync(name) {
        if (!name)
            throw new IChatMessageAttachmentStore_1.ChatMessageAttachmentStoreError(`Attachment=${name} should not be empty.`);
        const cmAttachmentDao = await this.db.chatMessageAttachments.get(name);
        if (!cmAttachmentDao || !cmAttachmentDao.attachment)
            throw new IChatMessageAttachmentStore_1.ChatMessageAttachmentStoreError(`Attachment=${name} doesn't exist.`);
        return cmAttachmentDao.attachment;
    }
    LoadFromStreamAsync(name) {
        throw new Error('Not Implemented');
    }
    async DeleteAsync(name) {
        await this.db.chatMessageAttachments.delete(name);
    }
    async IsInStorageAsync(name) {
        const cmAttachmentDao = await this.db.chatMessageAttachments.get(name);
        if (!cmAttachmentDao || !cmAttachmentDao.attachment)
            return false;
        return true;
    }
    async UpdateAttachmentReceivingStatusAsync(name, status) {
        if (!name)
            throw new IChatMessageAttachmentStore_1.ChatMessageAttachmentStoreError(`Attachment=${name} should not be empty.`);
        const cmAttachmentDao = await this.db.chatMessageAttachments.get(name);
        if (!cmAttachmentDao) {
            //Add case
            const cmas = new ChatMessageAttachmentStatus_1.ChatMessageAttachmentStatus({
                Name: name,
                Status: status,
            });
            await this.db.chatMessageAttachments.add({
                id: name,
                status: this.ToIChatMessageAttachmentStatusIndexedDbDao(cmas),
            });
        }
        else {
            //Update case
            const newCmas = this.ToChatMessageAttachmentStatus(cmAttachmentDao.status).ApplyReceivingStatus(status);
            await this.db.chatMessageAttachments.update(name, {
                status: this.ToIChatMessageAttachmentStatusIndexedDbDao(newCmas),
            });
        }
    }
    async UpdateAttachmentReceivingStatsAsync(name, cur, total) {
        if (!name)
            throw new IChatMessageAttachmentStore_1.ChatMessageAttachmentStoreError(`Attachment=${name} should not be empty.`);
        const cmAttachmentDao = await this.db.chatMessageAttachments.get(name);
        if (!cmAttachmentDao) {
            //Add case
            const cmas = new ChatMessageAttachmentStatus_1.ChatMessageAttachmentStatus({
                Name: name,
                CurBytes: cur,
                TotalBytes: total,
            });
            await this.db.chatMessageAttachments.add({
                id: name,
                status: this.ToIChatMessageAttachmentStatusIndexedDbDao(cmas),
            });
        }
        else {
            //Update case
            const newCmas = this.ToChatMessageAttachmentStatus(cmAttachmentDao.status).ApplyReceivingStats(cur, total);
            await this.db.chatMessageAttachments.update(name, {
                status: this.ToIChatMessageAttachmentStatusIndexedDbDao(newCmas),
            });
        }
    }
    async UpdateAttachmentSendingStatusAsync(name, status) {
        if (!name)
            throw new IChatMessageAttachmentStore_1.ChatMessageAttachmentStoreError(`Attachment=${name} should not be empty.`);
        const cmAttachmentDao = await this.db.chatMessageAttachments.get(name);
        if (!cmAttachmentDao) {
            this._logger.error(`Attachment=${name} not in store, cannot update status.`);
            return;
        }
        this._logger.debug(`Updating ${name} SendingStatus to ${status}`);
        const newCmas = this.ToChatMessageAttachmentStatus(cmAttachmentDao.status).ApplySendingStatus(status);
        await this.db.chatMessageAttachments.update(name, {
            status: this.ToIChatMessageAttachmentStatusIndexedDbDao(newCmas),
        });
    }
    async UpdateAttachmentSendingStatsAsync(name, status, cur, total) {
        if (!name)
            throw new IChatMessageAttachmentStore_1.ChatMessageAttachmentStoreError(`Attachment=${name} should not be empty.`);
        const cmAttachmentDao = await this.db.chatMessageAttachments.get(name);
        if (!cmAttachmentDao) {
            this._logger.error(`Attachment=${name} not in store, cannot update status.`);
            return;
        }
        this._logger.debug(`Updating ${name} SendingStatus to ${status} ${cur}/${total}`);
        const newCmas = this.ToChatMessageAttachmentStatus(cmAttachmentDao.status).ApplySendingStatusStats(status, cur, total);
        await this.db.chatMessageAttachments.update(name, {
            status: this.ToIChatMessageAttachmentStatusIndexedDbDao(newCmas),
        });
    }
    async QueryAttachmentStatusAsync(name) {
        if (!name)
            return ChatMessageAttachmentStatus_1.ChatMessageAttachmentStatus.INVALID;
        const cmAttachmentDao = await this.db.chatMessageAttachments.get(name);
        return cmAttachmentDao ? this.ToChatMessageAttachmentStatus(cmAttachmentDao.status) : ChatMessageAttachmentStatus_1.ChatMessageAttachmentStatus.INVALID;
    }
    async QueryAllAttachmentStatusAsync() {
        const allCmAttachmentStatus = [];
        await this.db.chatMessageAttachments.each(cmAttachmentDao => {
            allCmAttachmentStatus.push(new ChatMessageAttachmentStatus_1.ChatMessageAttachmentStatus(this.ToChatMessageAttachmentStatus(cmAttachmentDao.status)));
        });
        return allCmAttachmentStatus.sort((a, b) => {
            return a.LastUpdatedTime.getTime() - b.LastUpdatedTime.getTime();
        });
    }
    QueryAttachmentFilePathName(name) {
        throw new Error('Not Implemented');
    }
    PersistToStorage() {
        throw new Error('Not Implemented');
    }
    ToIChatMessageAttachmentStatusIndexedDbDao(cmas) {
        return {
            name: cmas.Name,
            isInStorage: cmas.IsInStorage,
            status: cmas.Status,
            curBytes: cmas.CurBytes,
            totalBytes: cmas.TotalBytes,
            createdTime: cmas.CreatedTime,
            lastUpdatedTime: cmas.LastUpdatedTime,
        };
    }
    ToChatMessageAttachmentStatus(cmasDao) {
        return new ChatMessageAttachmentStatus_1.ChatMessageAttachmentStatus({
            Name: cmasDao.name,
            IsInStorage: cmasDao.isInStorage,
            Status: cmasDao.status,
            CurBytes: cmasDao.curBytes,
            TotalBytes: cmasDao.totalBytes,
            CreatedTime: cmasDao.createdTime,
            LastUpdatedTime: cmasDao.lastUpdatedTime,
        });
    }
}
exports.ChatMessageAttachmentIndexedDbStore = ChatMessageAttachmentIndexedDbStore;
//# sourceMappingURL=ChatMessageAttachmentIndexedDbStore.js.map